export enum PaymentNomination {
    GENERAL_LIABILITY_INSURANCE = "GENERAL_LIABILITY_INSURANCE",
    PROFESSIONAL_LIABILITY_INSURANCE = "PROFESSIONAL_LIABILITY_INSURANCE",
    WORKERS_COMPENSATION_INSURANCE = "WORKERS_COMPENSATION_INSURANCE",
    DISABILITY_INSURANCE = "DISABILITY_INSURANCE",
}

export enum PaymentStatus {
    DRAFT = "DRAFT",
    APPROVED= "APPROVED",
    EXPORTED = "EXPORTED",
    SCHEDULED = "SCHEDULED",
    SETTLED = "SETTLED",
    RETURNED = "RETURNED",
    UNPAID = "UNPAID",
    COMPLETED = "COMPLETED",
    OVERDUE = "OVERDUE",
    CANCELLED = "CANCELLED",
    PENDING_FOR_ACTION = "PENDING_FOR_ACTION",
    PENDING = "PENDING",
    DECLINED = "DECLINED",
}

export enum PaymentMethod {
    CUSTOMER_CARD = "CUSTOMER_CARD",
    CUSTOMER_ACCOUNT = "CUSTOMER_ACCOUNT",
    SUBLIME_CARD = "SUBLIME_CARD",
    SUBLIME_ACCOUNT = "SUBLIME_ACCOUNT",
    CUSTOMER_BUSINESS_ACCOUNT = "CUSTOMER_BUSINESS_ACCOUNT",
    CUSTOMER_PERSONAL_ACCOUNT = "CUSTOMER_PERSONAL_ACCOUNT",
}

export enum BalanceEffect {
    INCREASE = "INCREASE",
    DECREASE = "DECREASE",
}

export enum TransactionType {
    LIABILITY = "LIABILITY",
    OBLIGATION_PAYMENT = "OBLIGATION_PAYMENT",
    PENALTY_ASSESSMENT = "PENALTY_ASSESSMENT",
    PENALTY_PAYMENT = "PENALTY_PAYMENT",
    INTEREST = "INTEREST",
    ADJUSTMENT = "ADJUSTMENT",
    CREDIT = "CREDIT",
    TAX_BILL_ASSESSMENT = "TAX_BILL_ASSESSMENT"
}